import { useEffect, useRef } from 'react';
import { isCustomFilter } from '@atlassian/jira-issue-navigator-actions-common/src/utils/filters/index.tsx';
import { useTrigger } from '@atlassian/post-office-context';
import { LIST_VIEW_ID } from '../../../common/constants.tsx';
import { useSelectedViewActions } from '../../../controllers/selected-view-state/index.tsx';
import { convertFilterIdToIssueNavigatorId } from '../../../common/utils/index.tsx';
import { useActiveJql } from '../../../services/active-jql/index.tsx';

const EXPLORE_LIST_TRIGGER = 'jira-nin-list-merge-modal-onboarding-explore-list-clicked';

export const SpotlightExploreListClickListener = () => {
	const { filterId } = useActiveJql();
	const { setView } = useSelectedViewActions();
	const hasClicked = useRef(false);

	const { isActive: isExploreListViewClicked } = useTrigger(EXPLORE_LIST_TRIGGER);

	useEffect(() => {
		if (!hasClicked.current && isExploreListViewClicked) {
			const newView =
				filterId && isCustomFilter(filterId)
					? convertFilterIdToIssueNavigatorId(filterId)
					: LIST_VIEW_ID;

			setView(newView, '');
			hasClicked.current = true;
		}
	}, [filterId, isExploreListViewClicked, setView]);

	return null;
};
